import React, {useEffect, useState} from "react";
import {FlyerPageSpotDto, PromoDto, SelectPageForTabsDto} from "../../../../dtos";
import styles from './TooltipDetailsPromoPopup.module.scss';
import {AsyncImageWithLoader} from "../../../../com/imageWithLoader/imageWithLoader";
import {ReactComponent as ImageWithError} from "../../../../assets/promos&items/image_error.svg";
import {OrangeButton} from "../../pagesTab/orangeBtn/OrangeButton";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {NonImagePlaceholder} from "../../nonImagePlaceholder/nonImagePlaceholder";

interface Props {
    promo: PromoDto,
    promotionTypeCaption: string;
    editPromotion: (e: React.MouseEvent<HTMLElement>) => void;
    isShowPromoCaption: boolean;
    frame?: FlyerPageSpotDto;
}


export const TooltipDetailsPromoPopup: React.FC<Props> = (
    {
        promo,
        promotionTypeCaption,
        editPromotion,
        isShowPromoCaption,
        frame
    }
) => {
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const isDisableEditBtn = flyerDetailsState.flyFstRec.fstCaption === "Published";
    let selectedPagesForTabState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const selectedPageImage = flyerDetailsState.flyerPages[selectedPagesForTabState.pageNo === 0 ? 0 : selectedPagesForTabState.pageNo - 1].flpImageUrl;

    const [imageSrc, setImageSrc] = useState<string>('');

    useEffect(() => {
        // promo.imageSelection = 1 (regardless of whether a Promo image exists or not, display the dummy Wine Glass.)
        // promo.imageSelection = 2 (regardless of whether a Promo image exists or not, display the Frame screenshot)
        // promo.imageSelection = 3 (If there is a Promo Image, display it. If not, display the Frame Image)
        switch (promo.imageSelection){
            case 1:
                setImageSrc('')
                break;
            case 2:
                setImageSrc(`frameImage${frame?.fpsRecId}`);
                break;
            case 3:
                setImageSrc(promo.flrImage ? promo.flrImage : `frameImage${frame?.fpsRecId}`);
                break;
        }
    }, [promo])

    return (
        <div>
            <div className={`layout_flex_row ${styles.row_with_image}`}>
                <div className={styles.image_wrapper}>
                    <AsyncImageWithLoader src={imageSrc}
                                          notUploadIcon={(<NonImagePlaceholder/>)}
                                          // frame={frame}
                                          // selectedPageImage={selectedPageImage}
                    />
                </div>
            </div>
            <div className={`layout_flex_row ${styles.row}`}>
                <div>
                    Promotion Code:
                </div>
                <div className={`${promo.flrCode?.length ? '' : styles.missing_property} ${styles.value_for_prop}`} title={promo.flrCode}>
                    {promo.flrCode?.length ? promo.flrCode : `Missing`}
                </div>
            </div>
            {
                isShowPromoCaption &&
                <div className={`layout_flex_row ${styles.row}`}>
                    <div>
                        Promotion type:
                    </div>
                    <div className={`${promotionTypeCaption.length ? '' : styles.missing_property} ${styles.value_for_prop}`} title={promotionTypeCaption}>
                        {promotionTypeCaption.length ? promotionTypeCaption : `Missing` }
                    </div>
                </div>
            }
            <div className={`layout_flex_row ${styles.row}`}>
                <div>
                    Promotion Caption
                </div>
                <div className={`${promo.flrCaption?.length ? '' : styles.missing_property} ${styles.value_for_prop}`} title={promo.flrCaption}>
                    {promo.flrCaption?.length ? promo.flrCaption : `Missing`}
                </div>
            </div>
            <div className={`layout_flex_row ${styles.button_wrapper}`}>
                <OrangeButton buttonName={`EDIT`} onClick={editPromotion} isDisabled={isDisableEditBtn}/>
            </div>
        </div>
    )
}